import React from 'react';

const formatCurrency = (value) => {
  const amount = Number(value || 0);
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
  }).format(amount);
};

const AdminSummaryCards = ({ stats }) => {
  const cards = [
    {
      label: 'Pending onboardings',
      value: stats?.pendingOnboarding ?? 0,
      helper: 'Awaiting compliance review',
      format: (val) => val,
    },
    {
      label: 'Approved deposits',
      value: stats?.approvedDeposits ?? 0,
      helper: 'Total user deposits',
      format: formatCurrency,
    },
    {
      label: 'Approved withdrawals',
      value: stats?.approvedWithdrawals ?? 0,
      helper: 'Total user withdrawals',
      format: formatCurrency,
    },
    {
      label: 'KYC compliant users',
      value: stats?.kycApproved ?? 0,
      helper: 'Users with approved KYC',
      format: (val) => val,
    },
  ];

  return (
    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
          <p className="text-sm text-slate-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-slate-900">{card.format(card.value)}</p>
          <p className="mt-1 text-xs text-slate-400">{card.helper}</p>
        </div>
      ))}
    </section>
  );
};

export default AdminSummaryCards;
